$(document).ready(function(){
  
  // dragon medical one form height calc
   if($(window).width() > 991){
    setTimeout(function(){
      var formHeight = $('.appoinment-form-wrapper#form').height();
      $('.appoinment-form-wrapper#form').css({
        'height':formHeight,
        'display':'flex',
        'align-items':'center'
      });
    },2000)
   }
  
  // dragon medical one readmore less
   $('.icon-content #readMore').click(function(){
     if($(this).siblings('.read_content').is(':hidden')){
       $(this).siblings('.read_content').show(200);
       $(this).hide(150);
     }else{
      $(this).siblings('.read_content').hide(200);
      $(this).show(150);
     }
   });

   $('.icon-content #readLess').click(function(){
      $(this).parent('.read_content').hide(200);
      $(this).parent().siblings('#readMore').show(150);
  })

});